import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Autocomplete, Grid, Pagination, PaginationItem, TextField, Typography } from "@mui/material";
import { DataGrid, GridCsvExportMenuItem, GridOverlay, GridToolbarContainer, GridToolbarExportContainer } from "@mui/x-data-grid";
import React, { Fragment, Suspense, memo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useStyle } from '../style';
import Loader from '../../../../../../src/components/loader/loader';

const CustomTable = ({ props, totals }) => {
    const classes = useStyle();
    const location = useLocation();

    const handleChange = (event, newValue) => {
        props.setRowsPerPage(newValue);
    };

    const csvOptions = { delimiter: ';' };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExportContainer>
                    <GridCsvExportMenuItem />
                </GridToolbarExportContainer>
            </GridToolbarContainer>
        );
    }

    const NoRowsOverlay = () => {
        return (
            <GridOverlay>
                <Typography>No data available</Typography>
            </GridOverlay>
        );
    };

    // Custom footer row, receives totals for filteredData from parent
    const CustomFooter = () => (
        <Grid>
            {totals && (
                <Grid
                    container
                    style={{
                        // background: "#f2f2f2",
                        background: "#e0e0e0",
                        fontWeight: 600,
                        borderTop: "1px solid #eee",
                        margin: 0,
                        width: "100%",
                        paddingLeft: 10,
                        paddingTop: 2,
                        paddingBottom: 2,
                    }}
                >
                    <Grid sx={{ minWidth: 70, maxWidth: 100, flex: 'none' }}>Total</Grid>
                    {/* <Grid sx={{ flex: 1, textAlign: "center" }} /> */}
                    <Grid sx={{ flex: 1, textAlign: "center" }} />
                    <Grid sx={{ flex: 1, textAlign: "center" }} />
                    <Grid sx={{ flex: 1, textAlign: "center" }}>{totals.Youtube}</Grid>
                    <Grid sx={{ flex: 1, textAlign: "center" }}>{totals.Facebook}</Grid>
                    <Grid sx={{ flex: 1, textAlign: "center" }}>{totals.Instagram}</Grid>
                    <Grid sx={{ flex: 1, textAlign: "center" }}>{totals.Others}</Grid>
                    <Grid sx={{ flex: 1, textAlign: "center" }}>{totals.Regular}</Grid>
                    <Grid sx={{ flex: 1, textAlign: "center" }}>{totals.Walkin}</Grid>
                </Grid>
            )}

            <Grid container className={classes.footer}>
                <Grid className={classes.paginationOne}>
                    <Autocomplete
                        disablePortal
                        id="rows-per-page"
                        value={props.rowsPerPage}
                        onChange={handleChange}
                        options={props.pageOption}
                        getOptionLabel={(option) => option.toString()}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className={classes.paginationAutocomplete}
                                size="small"
                            />
                        )}
                    />
                    <Typography variant="body1" color={"#ccc"} ml="6px">
                        rows per page
                    </Typography>
                </Grid>
                <Grid>
                    <Pagination
                        color="primary"
                        size="small"
                        count={
                            location.pathname === "reports/products"
                                ? Math.ceil(props.pageCount)
                                : Math.ceil(props.pageCount / props.rowsPerPage)
                        }
                        page={props.page + 1}
                        onChange={(event, newPage) => props.setPage(newPage - 1)}
                        boundaryCount={1}
                        renderItem={(item) => (
                            <PaginationItem
                                className={classes.pagination}
                                slots={{ previous: ArrowLeftIcon, next: ArrowRightIcon }}
                                {...item}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Grid>
    );

    return (
        <Fragment>
            <Grid className="bg-white p-2">
                {location.pathname === "/reports/customerSalesReport" && (
                    <Grid className="flex justify-end mr-3 mb-5">
                        <TextField
                            size="small"
                            placeholder="Search"
                        />
                    </Grid>
                )}
                <Suspense fallback={<Loader />}>
                    <DataGrid
                        rows={props.rows}
                        columns={props.columns}
                        density="compact"
                        className={classes.dataTable}
                        components={{
                            NoRowsOverlay,
                        }}
                        slots={{ toolbar: CustomToolbar, footer: CustomFooter }}
                        disableRowSelectionOnClick={true}
                        showColumnVerticalBorder={true}
                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector
                        paginationModel={{ page: props.page, pageSize: props.rowsPerPage }}
                        sx={{ '--DataGrid-overlayHeight': '300px', height: '65vh' }}
                        getRowHeight={() =>
                            location.pathname === '/reports/outlet-wallet-transferreport' ? 'auto' : ''
                        }
                    />
                </Suspense>
            </Grid>
        </Fragment>
    );
};

export default memo(CustomTable);
